export interface DocumentReference {
  // for table
  checked?: boolean;
  isLoading?: boolean;
  noDocsLinked?: number;
  isHeader?: boolean;
  blobDocumentId?: number;
  blobDocumentID?: number;
  blobDocumentAuxID?: number;
  fileNameAux?: string;

  documentSearchCode?: string;
  documentSearchDesc?: string;
  documentTypeDesc?: string;
  uploadDate?: string;
  uploadDateObj?: Date;
  // for upload
  customerReferenceType?: string;
  customerReference?: string;
  documentTypeCode?: string;
  cemexReferenceType?: string;
  cemexReference?: string;
  referenceDateObj?: Date;
  referenceDate?: string;
  fileName?: string;
  fileContent?: string;
  customerDocsStatus?: boolean;
  customerDocsStatusValue?: string;
  customerDocsBlobId?: number;
  referenceStatus?: boolean;
  // blobDocumentId?: number;
  // required
  customerCode: string;
  countryCode: string;
  errorCode?: string;
  error?: string;

  // field Version 2.1
  customerComments?: string;
  serviceCode?: string;
  serviceURL?: string;
  serviceParam?: string;
  dateStart?: string;
  dateStartObj?: Date;
  dateEnd?: string;
  dateEndObj?: Date;
  cemexValue?: string;
  customerDocsBlobDetId?: number;
  attachment?: any;
  guid?: string;
  // vesion 2.4
  linkedReferenced?: DocumentReference[];
  locationCode?: string;
  locationDesc?: string;
}

export interface DocumentsDTO {
  documents: Array<DocumentReference>;
}

// ======================================================================================

export interface BlobDocument {
  blobDocumentID: number;
  fileName: string;
  fileContent: string;
}

// =================================================================

export interface ConfigDocument {
  internalDocumentFlag: boolean;
  documentTypeCode: number;
  documentTypeDesc: string;
  selectFlag: boolean;
  checked?: boolean;
  bInternal?: number;
}

export interface ConfigDocumentsDTO {
  configDocuments: Array<ConfigDocument>;
}

// =================================================================

export interface RequestFile {
  guidRequestFile: string;
}

// =================================================================

export interface ZipFile {
  filesToProcess: number;
  totalFiles: number;
  fileContent?: string;
  fileName?: string;
}

export interface ZipFileBinaryFiles {
  filesToProcess: number;
  totalFiles: number;
  fileContent?: ArrayBuffer;
  fileName?: string;
  fileType?: string;
}

// =================================================================

export interface DeliveriesData {
  customerCode: string;
  companyCode: string;
  jobsites: any[];
  countryCode: string;
  invoiced: number;
  documentTypeCode: string;
  dateFrom: any;
  dateTo: any;
  ticketListFlag: boolean;
  dateCriteriaType: number;
  userId?: string;
}
